import axios from 'axios';
import * as utils from '@/apis/apiUtils';
import type { StandardCar, StandardCarShow } from '@/models/externalReports/standard/standardCar';
import type {
  StandardCarCreateOrUpdateParams,
  StandardCarUpdateReportIdParams,
} from '@/models/apis/externalReports/standard/standardCarRequest';
import {
  StandardCarCreateOrUpdateResponse,
  StandardCarShowResponse,
} from '@/models/apis/externalReports/standard/standardCarResponse';
import { convertStandardReportsResponseToStandardReports } from '@/apis/externalReports/standard/standard_report';

export default {
  async createOrUpdate(params: StandardCarCreateOrUpdateParams): Promise<StandardCar> {
    const { data } = await axios.post<StandardCarCreateOrUpdateResponse>(
      utils.getApiUrl('/external_reports/standard/cars'),
      params,
    );
    return convertStandardCarResponseToStandardCar(data);
  },
  async updateReportId(id: number, params: StandardCarUpdateReportIdParams): Promise<StandardCar> {
    const { data } = await axios.post<StandardCarCreateOrUpdateResponse>(
      utils.getApiUrl(`/external_reports/standard/cars/${id}`),
      params,
    );
    return convertStandardCarResponseToStandardCar(data);
  },
  async getStandardCars(): Promise<StandardCarShow[]> {
    const { data } = await axios.get<StandardCarShowResponse[]>(utils.getApiUrl('/external_reports/standard/cars'));
    return convertStandardCarsResponseToStandardCars(data);
  },
};
function convertStandardCarResponseToStandardCar(standardCar: StandardCarCreateOrUpdateResponse): StandardCar {
  return {
    id: standardCar.id,
    lat: standardCar.lat,
    lon: standardCar.lon,
    status: standardCar.status,
    ts: standardCar.ts,
    currentReportId: standardCar.current_report_id,
    userId: standardCar.user_id,
    statusDisp: standardCar.status_disp,
  };
}

function convertStandardCarsResponseToStandardCars(standardCars: StandardCarShowResponse[]): StandardCarShow[] {
  return standardCars.map(standardCar => ({
    id: standardCar.id,
    lat: standardCar.lat,
    lon: standardCar.lon,
    status: standardCar.status,
    ts: standardCar.ts,
    carName: standardCar.car_name,
    currentReportId: standardCar.current_report_id,
    userId: standardCar.user_id,
    statusDisp: standardCar.status_disp,
    report: standardCar.report ? convertStandardReportsResponseToStandardReports([standardCar.report])[0] : null,
    hanName: standardCar.han_name,
    tsIsNew: Boolean(standardCar.ts_is_new),
  }));
}
